import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "input-code",
  class: "form-label fw-medium text-black"
}, "Código", -1)
const _hoisted_3 = { class: "mb-15 mb-md-20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "input-name",
  class: "form-label fw-medium text-black"
}, "Nombre", -1)
const _hoisted_5 = { class: "mb-15 mb-md-20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "input-description",
  class: "form-label fw-medium text-black"
}, "Descripción", -1)
const _hoisted_7 = { class: "mb-15 mb-md-20" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "input-image",
  class: "form-label fw-medium text-black"
}, "URL de imagen", -1)
const _hoisted_9 = { class: "mb-15 mb-md-20" }
const _hoisted_10 = { class: "form-floating mb-15 mb-md-20" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_form, {
      ref: "formRecord",
      id: "formModal",
      onSubmit: _withModifiers(_ctx.save, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_b_form_input, {
                          class: "form-control fs-14 text-black shadow-none form-control-sm",
                          id: "input-code",
                          modelValue: _ctx.form.record.Code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.Code) = $event)),
                          placeholder: "Ingrese el código",
                          required: "",
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                          class: "form-control fs-14 text-black shadow-none form-control-sm",
                          id: "input-name",
                          modelValue: _ctx.form.record.Name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.Name) = $event)),
                          placeholder: "Ingrese el nombre de la dimensión",
                          required: "",
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_b_form_textarea, {
                          class: "form-control fs-14 text-black shadow-none form-control-sm",
                          id: "input-description",
                          modelValue: _ctx.form.record.Description,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.Description) = $event)),
                          placeholder: "Ingrese una breve descripción",
                          rows: "3"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_b_form_input, {
                          class: "form-control fs-14 text-black shadow-none form-control-sm",
                          id: "input-image",
                          modelValue: _ctx.form.record.ImageUrl,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.ImageUrl) = $event)),
                          placeholder: "https://...",
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_form_checkbox, {
                          id: "checkbox-status",
                          modelValue: _ctx.form.record.Status,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.Status) = $event)),
                          name: "checkbox-status"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Activo ")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_b_button, {
                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.record.Id ? 'Guardar cambios' : 'Agregar competencia'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                onClick: _ctx.cancel,
                class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}